<template>
  <div id="app">
    <transition name="component-fade" mode="out-in">
      <component :is="view"></component>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Home from "@/views/Home";
import Video from "@/components/Video";

export default {
  name: "App",
  components: { Video, Home },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState(["global"]),
    video() {
      return this.$store.getters.getVideo;
    },
    view() {
      return this.video ? "Video" : "Home";
    },
  },
};
</script>

<style>
#app {
  font-family: "Gotham", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: all 0.5s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
  /* transform: translate(100vw, 0); */
}
</style>
